
import {createSlice} from '@reduxjs/toolkit'
import { fetchapprovalstatus } from '../../action/master/approvalstatusAction'

interface approvalstatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: approvalstatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const approvalstatusSlice = createSlice({
  name: 'approvalstatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchapprovalstatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchapprovalstatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchapprovalstatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default approvalstatusSlice.reducer
